import { Fragment } from "react";
import IconBroadcaster from "../../../../components/Icon/IconBroadcaster/index";
import bannerDesktop from "./resources/images/bannerDesktop.svg";
import bannerMobile from "./resources/images/bannerMobile.svg";

import paraBannerDesktop from "./resources/images/paraBannerDesktop.svg";
import paraBannerMobile from "./resources/images/paraBannerMobile.svg";

const WinterLogo = ({ icon = <IconBroadcaster /> }) => {
    return (
        <Fragment>
            <svg
                width="443"
                height="49"
                viewBox="0 0 443 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="winterOlympicsBrandBannerLogo"
                role="img"
                aria-label="Beijing 2022"
            >
                <path
                    d="M100.386 0.151611V48.5263L92.3359 40.5302V0.151611H100.386Z"
                    fill="white"
                />
                <path
                    d="M152.149 0.151611V48.5263L144.1 40.5302V0.151611H152.149Z"
                    fill="white"
                />
                <path
                    d="M241.927 38.1805V23.742H250.015V41.8564C247.798 44.1298 245.146 45.9337 242.217 47.1609C239.289 48.3881 236.144 49.0135 232.969 48.9999C229.715 49.0276 226.491 48.3825 223.498 47.1051C220.63 45.8671 218.022 44.0993 215.808 41.8943C213.57 39.6522 211.772 37.0108 210.505 34.1066C209.218 31.1161 208.572 27.8884 208.611 24.6325C208.603 21.4224 209.247 18.2442 210.505 15.2911C211.736 12.4127 213.503 9.79532 215.714 7.57916C217.968 5.37992 220.606 3.61368 223.498 2.36841C226.488 1.08304 229.714 0.437613 232.969 0.473594H250.015L241.89 8.58342H232.969C230.816 8.56953 228.682 8.99506 226.699 9.834C224.75 10.625 222.974 11.7901 221.472 13.2636C219.99 14.753 218.801 16.5078 217.968 18.4365C217.108 20.4283 216.669 22.5766 216.68 24.7462C216.665 26.9101 217.104 29.053 217.968 31.037C218.8 32.946 219.975 34.6864 221.434 36.172C222.909 37.6611 224.667 38.84 226.605 39.6395C228.602 40.4749 230.747 40.9002 232.912 40.8901C236.122 40.9245 239.267 39.9793 241.927 38.1805Z"
                    fill="white"
                />
                <path
                    d="M127.868 0.303223H123.834V8.37515H127.868V40.7197H116.409V32.5909H108.359V40.7765C108.357 41.8332 108.563 42.8799 108.965 43.8568C109.368 44.8338 109.959 45.7217 110.705 46.4697C111.451 47.2177 112.337 47.8112 113.313 48.2162C114.288 48.6211 115.334 48.8295 116.39 48.8295H128.417C130.427 48.8295 132.354 48.031 133.775 46.6096C135.195 45.1882 135.994 43.2604 135.994 41.2502V0.303223H127.868Z"
                    fill="white"
                />
                <path
                    d="M42.9571 14.4575C42.9717 12.5699 42.5977 10.6994 41.8586 8.96254C40.3988 5.5572 37.6863 2.8436 34.2824 1.38327C32.5501 0.654892 30.6876 0.287396 28.8085 0.303225H4.03433V20.5588H0V28.6118H28.8085C29.6317 28.6074 30.446 28.782 31.195 29.1234C31.9072 29.4455 32.5504 29.9023 33.0891 30.4687C33.6159 31.0203 34.0393 31.6621 34.3392 32.3635C34.6403 33.0904 34.7948 33.8695 34.7938 34.6563C34.7897 35.4548 34.6355 36.2454 34.3392 36.9869C34.0537 37.7276 33.6164 38.4003 33.0553 38.9616C32.4942 39.5229 31.8218 39.9604 31.0814 40.246C30.3401 40.5399 29.5491 40.6879 28.7517 40.6818H12.1219V30.6772L4.03433 32.212V48.8106H28.8085C30.6908 48.8209 32.5548 48.4402 34.2824 47.6926C37.683 46.2274 40.3939 43.5154 41.8586 40.1134C42.5978 38.3832 42.9718 36.5189 42.9571 34.6373C42.9783 32.7619 42.6066 30.9027 41.8661 29.1796C41.1256 27.4565 40.0327 25.9077 38.6576 24.6327C40.0392 23.3267 41.1347 21.748 41.8748 19.9965C42.6149 18.245 42.9834 16.3589 42.9571 14.4575ZM34.396 16.8071C34.0997 17.5414 33.6586 18.2085 33.0988 18.7685C32.5391 19.3284 31.8723 19.7698 31.1382 20.0662C30.4031 20.3868 29.6105 20.5545 28.8085 20.5588H12.1219V8.41305H28.8085C29.6071 8.41343 30.3981 8.56783 31.1382 8.8678C31.8523 9.16086 32.4974 9.5997 33.0323 10.1563C33.5825 10.6965 34.0203 11.3406 34.3202 12.0511C34.6201 12.7915 34.7744 13.5828 34.7748 14.3817C34.8141 15.2075 34.6852 16.0327 34.396 16.8071Z"
                    fill="white"
                />
                <path
                    d="M192.416 0.227295V22.8135L200.523 33.6519V0.227295H192.416Z"
                    fill="white"
                />
                <path
                    d="M186.413 23.9315L160.086 0.227295V48.7915H168.136V19.725L200.524 48.8673V39.6585V36.6646L192.417 29.3507L186.413 23.9315Z"
                    fill="white"
                />
                <path
                    d="M80.1755 20.5398H62.8828C62.9027 22.6591 63.757 24.6852 65.2604 26.1785C66.7638 27.6719 68.795 28.5121 70.9136 28.517H80.1755V20.5398Z"
                    fill="white"
                />
                <path
                    d="M58.9056 40.7954V8.31821H84.2101V0.28418H58.5079C56.4985 0.28418 54.5715 1.08271 53.1507 2.5041C51.7298 3.92549 50.9316 5.8533 50.9316 7.86345V41.2123C50.9316 43.2224 51.7298 45.1502 53.1507 46.5716C54.5715 47.993 56.4985 48.7915 58.5079 48.7915H84.2101V40.7954H58.9056Z"
                    fill="white"
                />
                <path
                    d="M348.505 0H330.436C328.426 0 326.499 0.798528 325.078 2.21992C323.658 3.64131 322.859 5.56912 322.859 7.57927V40.9281C322.859 42.9382 323.658 44.866 325.078 46.2874C326.499 47.7088 328.426 48.5073 330.436 48.5073H348.505C350.514 48.5073 352.441 47.7088 353.862 46.2874C355.283 44.866 356.081 42.9382 356.081 40.9281V7.57927C356.081 5.56912 355.283 3.64131 353.862 2.21992C352.441 0.798528 350.514 0 348.505 0V0ZM348.05 40.4733H330.89V8.09087H348.05V40.4733Z"
                    fill="white"
                />
                <path
                    d="M314.11 0.0756836H278.445H278.369L286.419 8.10971H306.666V16.0869L306.609 16.1627L285.339 40.5869H285.358L278.369 48.6399H314.716V40.5869H296.855L314.716 19.5734V8.10971V0.0756836H314.11Z"
                    fill="white"
                />
                <path
                    d="M397.997 0.0756836H362.332H362.256L370.306 8.10971H390.553V16.0869L390.496 16.1627L369.226 40.5869H369.245L362.256 48.6399H398.603V40.5869H380.742L398.603 19.5734V8.10971V0.0756836H397.997Z"
                    fill="white"
                />
                <path
                    d="M442.393 0.0756836H406.709H406.652L414.683 8.10971H414.702H434.95V16.0869L434.874 16.1627L413.622 40.5869L406.652 48.6399H442.999V40.5869H425.138L442.999 19.5734V8.10971V0.0756836H442.393Z"
                    fill="white"
                />
            </svg>
            {icon}
        </Fragment>
    );
};

export const winterLogo = <WinterLogo />;

export const summerLogoDesktop = <img src={bannerDesktop} alt="" />;

export const summerLogoMobile = <img src={bannerMobile} alt="" />;

export const paraLogoDesktop = <img src={paraBannerDesktop} alt="" />;

export const paraLogoMobile = <img src={paraBannerMobile} alt="" />;
